import CreateReservationView from './CreateReservationView';

export default {
  CreateReservationView,
};
